import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

// ===== localStorage 초기 데이터 설정 =====
// Apps Script 연동 모드에서는 실제 스프레드시트 데이터만 사용합니다.
const initLocalStorage = async () => {
  if (!import.meta.env.DEV || import.meta.env.VITE_USE_MOCK_DATA !== 'true') return;

  const {
    mockWorkers,
    mockAdmins,
    mockCheckins,
    mockAlerts,
    mockAdminReplies,
    mockNotices,
    mockAdminNotes,
    mockCheckinRevisions,
  } = await import('./services/mockData');

  const keys = {
    workfit_workers: mockWorkers,
    workfit_admins: mockAdmins,
    workfit_checkins: mockCheckins,
    workfit_alerts: mockAlerts,
    workfit_replies: mockAdminReplies,
    workfit_notices: mockNotices,
    workfit_admin_notes: mockAdminNotes,
    workfit_checkin_revisions: mockCheckinRevisions,
  };

  Object.entries(keys).forEach(([key, val]) => {
    if (!localStorage.getItem(key)) {
      localStorage.setItem(key, JSON.stringify(val));
    }
  });
};

initLocalStorage().then(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
});
